// Iter58c — Global scroll restoration.
// Every push/replace navigation resets the scroll to the top of the page.
// Back/forward navigation (POP) is left alone so the browser's native
// scroll-position restore continues to work.
//
// Placed once inside <BrowserRouter> in App.js — no per-page opt-in needed.
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType(); // "POP" | "PUSH" | "REPLACE"

  useEffect(() => {
    // If the URL has a hash (e.g. #features), let the browser scroll to
    // that anchor instead of jumping to top.
    if (hash) return;
    if (navType === "POP") return; // browser handles back/forward
    // Use "instant" so users don't see a jarring animated scroll on every
    // click. Falls back to top for browsers that don't support the option.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash, navType]);

  return null;
};

export default ScrollToTop;
